import { render, staticRenderFns } from "./MedisBaseDetails.vue?vue&type=template&id=28063729&"
import script from "./MedisBaseDetails.vue?vue&type=script&lang=ts&"
export * from "./MedisBaseDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports